import * as etc from 'services/etc';
import { useQuery } from 'react-query';

export const EXCEL_LIST = 'EXCEL_LIST';
export const AUTH_STAFF_SEL = 'AUTH_STAFF_SEL';
export const AUTH_STAFF_ADD = 'AUTH_STAFF_ADD';
export const AUTH_STAFF_MOD = 'AUTH_STAFF_MOD';
export const AUTH_STAFF_DET = 'AUTH_STAFF_DET';
export const AUTH_STAFF_DEL = 'AUTH_STAFF_DEL';
export const ROOT_MODAL_VIEW = 'ROOT_MODAL_VIEW';

// 엑셀 다운로드 내역
export const ExcelList = (params, path = etc.EXCEL_API_PATH) => ({
  type: EXCEL_LIST,
  payload: {
    promise: etc.ExcelList(params, path)
  }
});

// polling 엑셀 다운로드 내역
export const usePollingExcelList = (params, path = etc.EXCEL_API_PATH) => {
  return useQuery(['usePollingExcelList', path, params], () => etc.pollingExcelList(params, path), {
    enabled: !!params,
    refetchOnWindowFocus: false,
    refetchInterval: 5000,
    retry: false
  });
};

// 계정 권환 관리 조회
export const AuthStaffSel = (params) => ({
  type: AUTH_STAFF_SEL,
  payload: {
    promise: etc.AuthStaffSel(params)
  }
});

// 권한 사용자 추가
export const AuthStaffAdd = (params) => ({
  type: AUTH_STAFF_ADD,
  payload: {
    promise: etc.AuthStaffAdd(params)
  }
});

// 권한 사용자 변경
export const AuthStaffMod = (params) => ({
  type: AUTH_STAFF_MOD,
  payload: {
    promise: etc.AuthStaffMod(params)
  }
});

// 권한 사용자 조회
export const AuthStaffDet = (params) => ({
  type: AUTH_STAFF_DET,
  payload: {
    promise: etc.AuthStaffDet(params)
  }
});

// 권한 사용자 삭제
export const AuthStaffDel = (params) => ({
  type: AUTH_STAFF_DEL,
  payload: {
    promise: etc.AuthStaffDel(params)
  }
});

// 엑셀 다운로드
/* export const ExcelDownload = (id, name) => ({
  type : EXCEL_DOWNLOAD,
  payload : {
    promise : etc.ExcelDownload(id, name)
  }
}); */

export const RootCommonModalAction = (modal) => ({
  type: ROOT_MODAL_VIEW,
  modal
});
